import { ele, TalkerAPI } from "cables-shared-client";

export default class PageOpRename
{
    constructor(targetElement)
    {
        this._iframe = targetElement.dataset.iframe;

        const oldName = targetElement.dataset.oldname;
        const newName = targetElement.dataset.newname;
        const opId = targetElement.dataset.opid;

        if (targetElement.dataset.showresult && targetElement.dataset.showresult !== "false")
        {
            if (window !== window.parent)
            {
                this._talkerAPI = new TalkerAPI(window.parent);
                const data = { "opId": opId, "oldName": oldName, "objName": newName };
                this._talkerAPI.send("opRenamed", data);
            }
        }
        const opNameInput = ele.byId("newfullname");
        if (opNameInput)
        {
            opNameInput.addEventListener("keypress", (event) =>
            {
                if (event.key === "Enter")
                {
                    event.preventDefault();
                    this.checkIfValid(oldName);
                }
            });

            if (opNameInput.value)
            {
                const parts = opNameInput.value.split(".");
                let lastPartLength = parts[parts.length - 1].length;
                if (parts.length > 1)
                {
                    opNameInput.setSelectionRange(opNameInput.value.length - lastPartLength, opNameInput.value.length);
                    opNameInput.focus();
                }
            }
        }
        const suggestionElements = ele.byQueryAll(".versionSuggestion");
        suggestionElements.forEach((suggest) =>
        {
            if (suggest.dataset.shortName)
            {
                suggest.addEventListener("click", (e) =>
                {
                    this.checkIfValid(oldName, suggest.innerText);
                });
            }
        });

        this.listOldVersions();
    }

    reallyRename(oldName)
    {
        const newName = ele.byId("newfullname").value;
        let url = "/op/rename/?doit=true&op=" + oldName + "&new=" + newName;
        if (this._iframe && this._iframe !== "false") url += "&iframe=true";
        document.location.href = url;
    }

    checkIfValid(oldName, newName = null)
    {
        newName = newName || ele.byId("newfullname").value;
        let url = "/op/rename/?checkit=true&op=" + oldName + "&new=" + newName;
        if (this._iframe && this._iframe !== "false") url += "&iframe=true";
        document.location.href = url;
    }

    changeNamespace()
    {
        const problemsEle = ele.byId("problems");
        if (problemsEle) ele.hide(problemsEle);

        const opNameInput = ele.byId("newfullname");
        const selectEle = ele.byId("newNamespace");

        if (selectEle.value)
        {
            ele.hide(ele.byId("dorenamebutton"));
            ele.show(ele.byId("checkbutton"));

            const opName = opNameInput.value;
            const opBasename = opName.substring(opName.lastIndexOf(".") + 1);
            const newNamespace = selectEle.value;
            const newOpName = newNamespace + opBasename;
            if (opNameInput) opNameInput.value = newOpName;
        }
    }

    changeOpName()
    {
        const problemsEle = ele.byId("problems");
        if (problemsEle) ele.hide(problemsEle);

        ele.hide(ele.byId("dorenamebutton"));
        ele.show(ele.byId("checkbutton"));
    }

    listOldVersions()
    {
        const newNameElement = ele.byId("newfullname");
        const oldVersionLinks = ele.byQueryAll(".oldVersion");
        oldVersionLinks.forEach((oldLink) =>
        {
            const oldOpName = oldLink.dataset.oldName;
            const oldVersionName = oldLink.dataset.oldName;
            const newVersionEle = oldLink.querySelector(".newVersion");

            if (oldOpName)
            {
                let carryVersion = "";
                const parts = oldOpName.split("_v", 2);
                if (parts.length > 1)
                {
                    carryVersion = "_v" + parts[1];
                }
                let newName = newNameElement.value.split("_v", 2)[0] + carryVersion;
                oldLink.href = "/op/rename/?op=" + oldVersionName + "&new=" + newName;
                if (newVersionEle) newVersionEle.innerText = newName;
            }
        });
    }

    close()
    {
        if (this._talkerAPI) this._talkerAPI.send("closeRenameDialog");
    }
}

